import { ApiAttributionModel } from "@incendium/api";
import { exhaustiveCheck } from "@incendium/inc-ts-helpers";

export const getAttributionTitle = (m: ApiAttributionModel): string => {
  switch (m) {
    case ApiAttributionModel.NO_MODEL_SELECTED:
      return ""
    case ApiAttributionModel.FIRST:
      return "First Touch";
    case ApiAttributionModel.LAST:
      return "Last Touch";
    case ApiAttributionModel.LAST_NON_DIRECT:
      return "Last Non-Direct Touch";
    // case "firstNon":
    //   return "First Non-Direct Touch";
    case ApiAttributionModel.POSITION_BASED:
      return "Position Based";
    case ApiAttributionModel.LINEAR:
      return "Linear";
    case ApiAttributionModel.IMPACTED:
      return "Impacted";
    case ApiAttributionModel.EBA:
      return "Effectiveness Based";
    case ApiAttributionModel.CUSTOM:
      return "Custom";

    default:
      exhaustiveCheck(m);
  }
};
